<template>
  <common-dialog ref="dialog" :title="title" width="1500px" :in-dialog="inDialog">
    <list ref="list"  >
       
    </list>
    <template slot="footer">
      <slot name="footer">
        <el-button type="primary" @click="selectData" >选择</el-button>
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import list from "./clothList";
import listDialogMixins from "@/mixins/listDialog";

export default {
  components: { commonDialog, list },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "单据列表",
    }
  },
  data() {
    return {
      params: {},
    };
  },
 
  methods: {
    selectData(){
        let list = this.$refs.list.list;
        this.$emit('select', list)
        this.close();
    }
   
  },
};
</script>